import { useContext } from "react";
import { ApplicationContextType, ApplicationContext } from "../contexts/application.context";

export const useApplication = (): ApplicationContextType => useContext(ApplicationContext);